import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';

@Injectable()
export class AppVersionProvider {
  public version: string = '0.2.7';
  public build: string = '20250207';
  type: string;

  constructor(public platform: Platform) {}

  getVersion(): string {
    return this.version;
  }

  getBuild(): string {
    return this.build;
  }

  getType() {
    return this.platform.ready().then(() => {
      if (this.platform.is('cordova')) {
        this.type = 'mobile';
        return this.type;
      } else {
        this.type = 'web';
        return this.type;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/app-version/app-version.ts